import { useState, useCallback, useRef } from 'react';
import API_BASE_URL from '../config/api';

const useAiVoiceInput = () => {
    const [voiceResponse, setVoiceResponse] = useState('');
    const isProcessingRef = useRef(false);
    const lastProcessedFileRef = useRef(null);

    const getVoiceResponse = useCallback(async (audioFile, language = null) => {
        // Prüfen ob es die gleiche Datei ist
        if (lastProcessedFileRef.current === audioFile) {
            console.log('Already processed this file');
            return;
        }

        // Prüfen ob gerade verarbeitet wird
        if (isProcessingRef.current) {
            console.log('Currently processing another file');
            return;
        }

        try {
            isProcessingRef.current = true;
            lastProcessedFileRef.current = audioFile;

            // Audio-Datei in Base64 konvertieren
            const arrayBuffer = await audioFile.arrayBuffer();
            const base64Audio = btoa(
                new Uint8Array(arrayBuffer)
                    .reduce((data, byte) => data + String.fromCharCode(byte), '')
            );

            // Über Backend-Route transkribieren (verwendet gpt-4o-mini-transcribe)
            const res = await fetch(`${API_BASE_URL}/api/ai/transcribe`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ 
                    audio: base64Audio,
                    language: language 
                })
            });

            if (!res.ok) {
                const errorData = await res.json();
                throw new Error(errorData.error || 'Transcription failed');
            }

            const data = await res.json();
            setVoiceResponse(data.text);
            return data.text;
        } catch (error) {
            console.error('Error fetching transcription:', error);
            throw error;
        } finally {
            isProcessingRef.current = false;
        }
    }, []);

    return { voiceResponse, getVoiceResponse };
};

export default useAiVoiceInput;
